module.exports = __webpack_public_path__ + "static/anli3.449b8532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anli3.jpg
// module id = 716
// module chunks = 168707334958949